import React from 'react';
import Button from '../../../../../../../shared/design-system/components/atoms/button';
import ConfirmationModalV3 from '../../../../../../../shared/design-system/components/atoms/confirmation-modal/confirmation-modal-v3';
import { ConfirmationModalIconType } from '../../../../../../../shared/design-system/components/atoms/confirmation-modal/enum';

const DeleteTeamModal = ({ show, onSubmit, onClose, isLoading }) => (
  <ConfirmationModalV3
    show={show}
    iconType={ConfirmationModalIconType.TRASH_RED}
    title="Delete Team"
    contents={[
      'Are you sure you want to delete the selected team?',
      'Once deleted, all members will be unassigned from the team and team will be removed from the account.',
    ]}
    cancelButtonText="Cancel"
    submitButtonText="Delete"
    submitButtonVariant={Button.Variant.Danger}
    onSubmit={onSubmit}
    onClose={onClose}
    submitButtonClassName="delete-btn"
    cancelButtonClassName="cancel-btn"
    isSubmitDisabled={isLoading}
    isSubmitLoading={isLoading}
    className="action-modal"
  />
);

export default DeleteTeamModal;
